<template>
	<div>
		<!--弹出框-->
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="height: 100%">
			<el-dialog title="角色管理" :modal="false" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
				<el-row>
					<el-col :span="24">
						<el-form-item type="type" label="字段类型" prop="lx">
							<el-input type="type" placeholder="字段类型" class="from-el-input" v-model.trim="ruleForm.lx"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item type="type" label="字典名称" prop="mc">
							<el-input type="type" placeholder="字典名称" class="from-el-input" v-model.trim="ruleForm.mc"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item type="type" label="字典值" prop="val">
							<el-input type="type" placeholder="字典值" class="from-el-input" v-model.trim="ruleForm.val"></el-input>
						</el-form-item>
					</el-col>

				</el-row>
				<span slot="footer" class="dialog-footer">
                    <el-form-item>
                        <el-button round @click="empty()" type="warning">取消</el-button>
                        <el-button round v-if="state=='xz'" type="primary" @click="deteRmine('ruleForm','xz')">保 存</el-button>
                        <el-button round v-if="state=='childadd'" type="primary" @click="deteRmine('ruleForm','xz')">保 存</el-button>
                        <el-button round v-if="state=='bj'" type="primary" @click="deteRmine('ruleForm','bj')">保 存</el-button>
                    </el-form-item>
                </span>
			</el-dialog>
		</el-form>
		<!--弹出框-->
	</div>
</template>

<script>
	import { dictionsave,dictionUpdate } from "@/api/api.js";

	export default {
		props: {
			mystate: Array
		},
		data() {
			return {
				dialogVisible: true,
				ruleForm: {
					lx: '',
					mc: '',
					val:'',
					
				},
				rules: {
					lx: [
						{ required: true, message: "请输入必填项", trigger: "blur" },
						{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
					],
					mc: [
						{ required: false, message: "请输入必填项", trigger: "blur" },
						{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
					],
					val: [
						{ required: false, message: "请输入必填项", trigger: "blur" },
						{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
					],
				},
				datatree: [],
				defaultProps: { /// tree设置
					children: 'subList',
					label: 'menuName'
				},
				treesid: '',
				state: '',
				row:null,
				parentId:null,
			};
		},
		created() {
			//初始化数据
		},
		components: {},
		methods: {
			cancel() {},
			deteRmine(formName, type) {
				this.$refs[formName].validate(valid => {
					if(valid) {
						if(type=='xz'){
							let params = {
								type: this.ruleForm.lx,
								code:this.ruleForm.val,
								name:this.ruleForm.mc,
								parentId:this.parentId,	
							}
							dictionsave(params).then((res) => {
								if(res.code === 200) {
									this.$notify({
										title: "提示",
										message: "提交成功",
										type: "success"
									});
									this.dialogVisible = false;
									this.$emit("adddata", {
										dialogVisible: this.dialogVisible
									});
								} else {
									this.$notify({
										title: "提示",
										message: res.message,
										type: "warning"
									});
								}
							})
						}else{
							let params = {
								type: this.ruleForm.lx,
								code:this.ruleForm.val,
								name:this.ruleForm.mc,
								//parentId:this.parentId,	
								id:this.row.id
							}
							dictionUpdate(params).then((res) => {
								if(res.code === 200) {
									this.$notify({
										title: "提示",
										message: "提交成功",
										type: "success"
									});
									this.dialogVisible = false;
									this.$emit("adddata", {
										dialogVisible: this.dialogVisible
									});
								} else {
									this.$notify({
										title: "提示",
										message: res.message,
										type: "warning"
									});
								}
							})
						}
						
						
					} else {
						this.$notify({
							title: '提示',
							message: '请填写完整后再提交',
							type: 'warning'
						})
						return false
					}
				});
			},
			empty() {
				this.dialogVisible = false;
				this.$emit("getcancel", {
					dialogVisible: this.dialogVisible
				});
			},
			handleClose() {
				this.dialogVisible = false;
				this.$emit("getcancel", {
					dialogVisible: this.dialogVisible
				});
			},
			handleNodeClick() {

			},

		},
		mounted() {
			this.state = this.mystate[0];
			
			if(this.state=='xz'){
				this.parentId = 0;
			}
			if(this.state=='childadd'){
				this.row = this.mystate[1];
				this.parentId = this.row.id;
			}
			if(this.state=='bj'){
				this.row = this.mystate[1];
				//this.parentId = this.row.parentId;
				
				this.ruleForm.lx = this.row.type
				this.ruleForm.val = this.row.code
				this.ruleForm.mc = this.row.name
			}

		}
	};
</script>

<style scoped="scoped">
	>>>.el-dialog {
		width: 700px;
	}
	
	>>>.el-dialog__body {
		max-height: 500px;
		overflow: auto;
	}
	
	.trees {
		width: 98%;
		float: left;
		max-height: 300px;
		height: 60px;
		line-height: 30px;
		padding-left: 2%;
		margin-top: 5px;
	}
</style>